import React from 'react';

import { BRAND_ASSETS } from '../brand/assets';

interface HeroFlyerProps {
  children?: React.ReactNode;
  /** When false, renders text/content only (no recruitment flyer image). */
  showFlyerImage?: boolean;
}

/** Full-width recruitment flyer hero with optional content below. */
const HeroFlyer: React.FC<HeroFlyerProps> = ({ children, showFlyerImage = true }) => {
  return (
    <div className="hero-flyer card">
      {showFlyerImage ? (
        <img
          src={BRAND_ASSETS.recruitmentFlyer}
          alt="Research the future of mental health — Wisemen Research Group"
          className="hero-flyer__image"
        />
      ) : null}
      {children ? <div className="hero-flyer__body">{children}</div> : null}
    </div>
  );
};

export default HeroFlyer;
